export default function rgbToInteger(rgb: string): number {
  const match = rgb.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (!match) throw new Error('Invalid RGB color value');
  const red = parseInt(match[1]);
  const green = parseInt(match[2]);
  const blue = parseInt(match[3]);
  return (red << 16) + (green << 8) + blue;
}
